import type { plans } from '@/lib/client';
import { CHANNEL_LABELS, CHANNEL_STYLES, STATUS_LABELS, STATUS_STYLES } from '@/lib/plans';
import { cn } from '@/lib/utils';

/** The plan's status; `label` overrides the word (a stopped run reads "Stopped", lib/plans.ts `statusLabel`). */
export function StatusChip({ status, label, className }: { status: plans.PlanStatus; label?: string; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold tracking-wide', STATUS_STYLES[status], className)}>
      {label ?? STATUS_LABELS[status]}
    </span>
  );
}

/** A step the API handed to the browser agent during the run: where it was planned, then where it ran. */
export function MovedBadge({ from, to, why }: { from: plans.Channel; to: plans.Channel; why?: string }) {
  return (
    <span className="inline-flex items-center gap-1" title={why === undefined ? undefined : `Moved to the browser: ${why}`}>
      <ChannelBadge channel={from} className="opacity-50 line-through" />
      <span className="text-[10px] text-muted-foreground" aria-hidden>→</span>
      <ChannelBadge channel={to} />
    </span>
  );
}

export function ChannelBadge({ channel, className }: { channel: plans.Channel; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider', CHANNEL_STYLES[channel], className)}>
      {CHANNEL_LABELS[channel]}
    </span>
  );
}
